import { render, staticRenderFns } from "./shiyong.vue?vue&type=template&id=5826b262&scoped=true&"
var script = {}
import style0 from "./shiyong.vue?vue&type=style&index=0&id=5826b262&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5826b262",
  null
  
)

export default component.exports